import {
    Image, TouchApp, Usb, BatteryChargingFull, OfflineBolt,
    CameraAlt, Mic, MicNone, FlashOn, VolumeDown, VolumeUp,
    Vibration, Call, Adjust, Headset, Fingerprint,
    Wifi, Bluetooth, Nfc, Camera, RecordVoiceOver,
    BrightnessHigh, Memory, SettingsInputComponent, Smartphone,
    Build, NetworkCheck, ScreenLockPortrait,
} from '@material-ui/icons'

export const TEST_ICON_MAP = {
    Image,
    TouchApp,
    Usb,
    BatteryChargingFull,
    OfflineBolt,
    CameraAlt,
    Mic,
    MicNone,
    RecordVoiceOver,
    FlashOn,
    Camera,
    VolumeDown,
    VolumeUp,
    Vibration,
    Call,
    Adjust,
    Headset,
    Fingerprint,
    Wifi,
    Bluetooth,
    Nfc,
    BrightnessHigh,
    Memory,
    SettingsInputComponent,
    Smartphone,
    Build,
    NetworkCheck,
    ScreenLockPortrait,
}

export const TEST_ICON_OPTIONS = [
    { name: 'Image',                label: 'Imagen' },
    { name: 'TouchApp',             label: 'Táctil' },
    { name: 'Usb',                  label: 'USB / Carga cable' },
    { name: 'BatteryChargingFull',  label: 'Batería / Carga' },
    { name: 'OfflineBolt',          label: 'Carga inalámbrica' },
    { name: 'CameraAlt',            label: 'Cámara trasera' },
    { name: 'Camera',               label: 'Cámara frontal' },
    { name: 'FlashOn',              label: 'Flash' },
    { name: 'Mic',                  label: 'Micrófono' },
    { name: 'MicNone',              label: 'Micrófono 2' },
    { name: 'RecordVoiceOver',      label: 'Micrófono voz' },
    { name: 'VolumeDown',           label: 'Volumen / Silencio' },
    { name: 'VolumeUp',             label: 'Altavoz' },
    { name: 'Vibration',            label: 'Vibración' },
    { name: 'Call',                 label: 'Llamadas' },
    { name: 'Adjust',               label: 'Sensor proximidad' },
    { name: 'Headset',              label: 'Auricular' },
    { name: 'Fingerprint',          label: 'Huella / FaceID' },
    { name: 'Wifi',                 label: 'WiFi' },
    { name: 'Bluetooth',            label: 'Bluetooth' },
    { name: 'Nfc',                  label: 'NFC' },
    { name: 'BrightnessHigh',       label: 'Pantalla / Brillo' },
    { name: 'Memory',               label: 'Memoria / SIM' },
    { name: 'SettingsInputComponent', label: 'Conector' },
    { name: 'ScreenLockPortrait',   label: 'Botón encendido' },
    { name: 'NetworkCheck',         label: 'Red móvil' },
    { name: 'Smartphone',           label: 'Dispositivo' },
    { name: 'Build',                label: 'Reparación' },
]

export const DEFAULT_TEST_ITEMS = [
    { icon: 'Image',                name: 'Imagen' },
    { icon: 'TouchApp',             name: 'Táctil' },
    { icon: 'Usb',                  name: 'Carga A' },
    { icon: 'BatteryChargingFull',  name: 'Carga B' },
    { icon: 'OfflineBolt',          name: 'Wireless' },
    { icon: 'CameraAlt',            name: 'Cámaras traseras' },
    { icon: 'Mic',                  name: 'Micro trasero' },
    { icon: 'Camera',               name: 'Cámara frontal' },
    { icon: 'MicNone',              name: 'Micro frontal' },
    { icon: 'FlashOn',              name: 'Flash' },
    { icon: 'RecordVoiceOver',      name: 'Micro inferior' },
    { icon: 'VolumeDown',           name: 'Botones vol./sil.' },
    { icon: 'Vibration',            name: 'Vibrador' },
    { icon: 'Call',                 name: 'Llamadas' },
    { icon: 'Adjust',               name: 'Sensor prox.' },
    { icon: 'Headset',              name: 'Sonido auricular' },
    { icon: 'VolumeUp',             name: 'Sonido altavoz' },
    { icon: 'Fingerprint',          name: 'Huella/FaceID' },
    { icon: 'Wifi',                 name: 'WiFi' },
    { icon: 'Bluetooth',            name: 'Bluetooth' },
    { icon: 'Nfc',                  name: 'NFC' },
]
